import type { RouteObject } from 'react-router';

import { CategoriesPage } from './Categories';

/**
 * The genre tree. One `RouteObject`, so the file is `.route.tsx` singular; the
 * feature's two routes are aggregated one level up in `taxonomy.routes.tsx`.
 *
 * `taxonomy/` is a bucket in the UI/UX pack and a segment in this URL, but it is
 * **not a route**: there is no `/taxonomy` landing page, which is why the
 * breadcrumb on this surface carries two levels rather than three.
 *
 * It sits inside the console layout route, which already runs the guard chain —
 * `sessionInMemory? → silentRefreshOnceOn401 → me() → roleGate` — so this route
 * adds no loader of its own. The guard decides **navigation**; every read and
 * every write on this surface is authorized by `backend-content` on the request
 * itself, and the origin a call arrives from is never an authorization input.
 */
export const categoriesRoute: RouteObject = {
  path: 'taxonomy/categories',
  element: <CategoriesPage />,
};
